
import { Link } from 'react-router-dom';

interface RegistrationFooterProps {
  type: 'participant' | 'organizer';
}

const RegistrationFooter: React.FC<RegistrationFooterProps> = ({ type }) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between w-full gap-2 text-center sm:text-left">
      <div className="text-sm text-muted-foreground">
        Már van fiókja? <Link to="/login" className="underline font-medium">Bejelentkezés</Link>
      </div>
      {type === 'participant' ? (
        <div className="text-sm text-muted-foreground">
          <Link to="/register/organizer" className="underline font-medium">Szervezőként szeretne regisztrálni?</Link>
        </div>
      ) : (
        <div className="text-sm text-muted-foreground">
          <Link to="/register/participant" className="underline font-medium">Résztvevőként szeretne regisztrálni?</Link>
        </div>
      )}
    </div>
  );
};

export default RegistrationFooter;
